module.exports = __webpack_public_path__ + "media/src/images/mails/68cce6-543137c6397afda396eda8069ae2e468.png";